import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import config from '../../config'
import {GET_CITY_API} from './actionTypes'
import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {getCookie} from '../../utils/cookie'
import config from '../../config'

const homePage = (process.env.NODE_ENV === 'development') ?
  true : window.theme.isHomePage
const cityAlias = !homePage ? window.theme.cityAlias : false


const useCityAPIActions = () => {
  const dispatch = useDispatch()
  const getCityApi = useCallback(
    async () => {
      dispatch({
        type: GET_CITY_API,
        payload: await fetchData(`/${cityAlias}/get-city-api`)
      })
    },
    [dispatch],
  )

  return {getCityApi}
}

export default useCityAPIActions

